<template>
    <div class="container">
        <div class="hero-box d-flex align-items-center" v-if="heroImageIsActive">
            <img :src="heroImage" class="img img-fluid w-100" />
            <div class="col-12 content">
                <h1 v-html="getHeadline"></h1>
                <p v-html="getText"></p>
                <b-link v-if="!isAboutSubscriptionPage && getHeadline && getText" :to="$getUrl('about-subscription')" class="btn btn-primary">
                    {{$t('cat.about_subscription')}}
                </b-link>
            </div>
        </div>
    </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
    name: 'HeroBox',
    components: {
        BLink,
    },
    data(){
        return {
            whitelabel: this.$root.whitelabel.state.settings,
        }
    },
    computed: {
        isAboutSubscriptionPage(){
          return this.$route.name === 'about-subscription'
        },
        getText(){
            return this.whitelabel.hero_image_text ? this.whitelabel.hero_image_text : ''
        },
        getHeadline(){
            return this.whitelabel.hero_image_headline ? this.whitelabel.hero_image_headline : ''
        },
        heroImage() {
            if(this.$root.breakpoints.gt.lg) {
                return this.whitelabel.hero_image_desktop
            }
            else if(this.$root.breakpoints.gt.md) {
                return this.whitelabel.hero_image_tablet
            }
            else {
                return this.whitelabel.hero_image_mobile
            }
        },
        heroImageIsActive() {
            return this.whitelabel && this.whitelabel.hero_isActive
        }
    },
}
</script>
